import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageKeys } from '../../shared/models/local-storage.model';

@Component({
  selector: 'app-two-factor-setup-page',
  templateUrl: './two-factor-setup-page.component.html'
})
export class TwoFactorSetupPageComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    if (!localStorage.getItem(LocalStorageKeys.TwoFactorChallenge)) {
      this.router.navigate(['/login']);
    }
  }

  onCompleted() {
    // Potwierdzenie kodem podczas enrollmentu wystawia pełny JWT (hasło + kod
    // z nowego urządzenia), więc od razu wchodzimy do aplikacji.
    this.router.navigate(['/']);
  }
}
